
























import Vue from 'vue';
import OctLastViewedDepots from "@/components/Dashboard/OctLastViewedDepots.vue";
import OctDepotSearch from "@/components/Dashboard/OctDepotSearch.vue";
import OctDepotKpi from "@/components/Dashboard/OctDepotKpi.vue";

export default Vue.extend({
  name: 'dashboard',
  components: {
    OctLastViewedDepots,
    OctDepotSearch,
    OctDepotKpi,
  },
  data: () => ({
  }),
  computed: {
  },
  created() {
  }
});
